import React from "react";

/**
 * Mui Components
 */
import { Link, List, ListItem, Typography } from "@mui/material";

/**
 * Third party libraries
 */
import parse, { domToReact } from "html-react-parser";

interface RichTextProps {
  htmlContent: string;
}

interface CustomComponentMap {
  [key: string]: React.FC<{ children: React.ReactNode; [key: string]: any }>;
}

const RichText: React.FC<RichTextProps> = ({ htmlContent }) => {
  const customComponentMap: CustomComponentMap = {
    p: ({ children }) => (
      <Typography variant="bodyMedium">{children}</Typography>
    ),
    ul: ({ children }) => (
      <List sx={{ listStyleType: "disc", pl: 1.75 }}>{children}</List>
    ),
    li: ({ children }) => (
      <ListItem sx={{ my: 0.5, mx: 0, display: "list-item", py: 0, px: 0.5 }}>
        {children}
      </ListItem>
    ),
    a: ({ children, href, ...rest }) => {
      return (
        <Link href={href} {...rest} sx={{ color: "primary.main" }}>
          {children}
        </Link>
      );
    },
  };

  const options = {
    replace: (node: any) => {
      const { name, children, attribs } = node;
      if (customComponentMap[name]) {
        return customComponentMap[name]({
          // @ts-ignore
          children: domToReact(children, options),
          ...attribs,
        });
      }
    },
  };

  // @ts-ignore
  const parsedHtml = parse(htmlContent, options);

  return <div>{parsedHtml}</div>;
};

export default RichText;
